import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  const painPoints = [{
    title: 'Patrones repetitivos en el amor',
    description: 'Atraes el mismo tipo de pareja o dinámica dolorosa una y otra vez, sin importar cuánto intentes cambiar.'
  }, {
    title: 'Culpa al alcanzar el éxito',
    description: 'Sientes un peso inexplicable o te saboteas justo cuando estás a punto de lograr tus metas o ganar más dinero.'
  }, {
    title: 'Ansiedad sin razón aparente',
    description: 'Cargas con miedos, tristeza o angustia que no parecen tener una causa lógica en tu propia historia de vida.'
  }, {
    title: 'Sensación de estancamiento',
    description: 'Sientes que hay un muro invisible que te impide avanzar, como si estuvieras atada a algo que no puedes ver.'
  }];
  return <section className="py-24 bg-beige-light relative" data-id="element-198">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-199">
        <FadeIn className="text-center mb-16" data-id="element-200">
          <span className="text-sage-dark font-medium tracking-widest uppercase text-sm mb-4 block" data-id="element-201">
            El Diagnóstico
          </span>
          <h2 className="font-heading text-4xl md:text-5xl text-charcoal mb-6" data-id="element-202">
            ¿Te reconoces en alguna de estas situaciones?
          </h2>
          <div className="w-24 h-[1px] bg-gold mx-auto" data-id="element-203" />
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-16" data-id="element-204">
          {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-205">
              <div className="bg-beige p-8 rounded-sm shadow-sm border border-gold/10 hover:border-gold/30 transition-colors duration-300 h-full" data-id="element-206">
                <div className="w-10 h-10 rounded-full bg-sage/20 flex items-center justify-center mb-6" data-id="element-207">
                  <span className="text-sage-dark font-heading italic text-xl" data-id="element-208">
                    {index + 1}
                  </span>
                </div>
                <h3 className="font-heading text-2xl text-charcoal mb-3" data-id="element-209">
                  {point.title}
                </h3>
                <p className="font-body text-charcoal/70 leading-relaxed" data-id="element-210">
                  {point.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}